import { useEffect } from 'react';

const useTriggerAction = (ids, callback, eventName = 'click') => {
  useEffect(() => {
    const idList = Array.isArray(ids) ? ids : [ids];
    let frameId;
    let retryCount = 0;
    const maxRetries = 10;

    const tryAttachListeners = () => {
      const elements = idList
        .map((id) => {
          if (!id) {
            return [];
          }

          const foundByDataAttr = Array.from(
            document.querySelectorAll(`[data-element-id="${id}"]`)
          );
          const fallbackById = document.getElementById(id);
          const found = [...foundByDataAttr];

          if (fallbackById && !found.includes(fallbackById)) {
            found.push(fallbackById);
          }

          return found;
        })
        .flat();

      if (elements.length > 0 || retryCount >= maxRetries) {
        if (retryCount >= maxRetries && elements.length === 0) {
          return;
        }

        const handler = (event) => {
          const target = event.currentTarget;
          if (typeof target.disabled === 'boolean' && target.disabled) {
            return;
          }
          callback(event);
        };

        elements.forEach((el) => {
          el.addEventListener(eventName, handler);
        });

        return () => {
          elements.forEach((el) => {
            el.removeEventListener(eventName, handler);
          });
        };
      } else {
        retryCount++;
        frameId = requestAnimationFrame(tryAttachListeners);
      }
    };

    frameId = requestAnimationFrame(tryAttachListeners);

    return () => {
      if (frameId) cancelAnimationFrame(frameId);
    };
  }, [ids, callback, eventName]);
};

export default useTriggerAction;
